const KEY = "reef_utm";
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

export function captureUtm() {
  try {
    const q = new URLSearchParams(window.location.search);
    const found = {};
    PARAMS.forEach((p) => {
      const v = q.get(p);
      if (v) found[p.replace("utm_", "")] = v.slice(0, 200);
    });
    if (!Object.keys(found).length) return;
    const prev = getUtm() || {};
    localStorage.setItem(
      KEY,
      JSON.stringify({
        ...prev,
        ...found,
        landing_page: window.location.pathname,
        captured_at: new Date().toISOString(),
      })
    );
  } catch {}
}

export function getUtm() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { captured_at, ...utm } = JSON.parse(raw);
    return Object.keys(utm).length ? utm : null;
  } catch {
    return null;
  }
}
